import React from 'react';
import { Menu } from 'antd';
import Skill from '../../images/logos/skill.png'
import Service from '../../images/logos/service.png'
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';
import { compose } from 'redux';
require('../../styles/sidenav.css');

class SideMenu extends React.Component {

  render() {
    const { t, selectedProduct } = this.props;
    let url = this.props.location.split('/')
    let isServiceTracker = url.includes('servicetracker')
    let menuLocation = isServiceTracker ? [url[2]] : [url[1]]

    return (
      <Menu
        selectedKeys={menuLocation}
        mode="inline"
        style={styles.menu}
      >

        <div style={styles.head}>
          <img src={selectedProduct && selectedProduct == 'ServiceTracker' ? Service : Skill} style={styles.logo} alt="Skilltracker logo" />
          <div id="sidenav_title" style={styles.title}>

            {selectedProduct === 'SkillTracker' ?
              <div>
                <p style={{ marginTop: '20px', marginBottom: '25px' }}>{t('teacherdashboard')}</p>
                <p>{t('Dashboard')}</p>
              </div>
              :
              <div>
                <p style={{ marginTop: '20px', marginBottom: '25px' }}>{t('Service')}</p>
                <p>{t('Tracker')}</p><
              /div>}
          </div>
        </div>

        {selectedProduct === 'SkillTracker' && <Menu.Item key="myclasses">
          <Link to="/myclasses"><span>{t('My Classes')}</span></Link>
        </Menu.Item>}

        {selectedProduct === 'SkillTracker' && <Menu.Item key="allclasses">
          <Link to="/allclasses"><span>{t('All Classes')}</span></Link>
        </Menu.Item>}

        {selectedProduct === 'SkillTracker' && <Menu.Item key="school">
          <Link to="/school/generalinfo"><span>{t('School')}</span></Link>
        </Menu.Item>}

        {selectedProduct === 'ServiceTracker' && <Menu.Item key="progressoverview">
          <Link to="/servicetracker/progressoverview"><span>{t('Progress Overview')}</span></Link>
        </Menu.Item>}

        {selectedProduct === 'ServiceTracker' && <Menu.Item key="tagoverview">
          <Link to="/servicetracker/tagoverview"><span>{t('Tag Overview')}</span></Link>
        </Menu.Item>}
        {selectedProduct === 'ServiceTracker' && <Menu.Item key="individualprojects">
          <Link to="/servicetracker/individualprojects"><span>{t('Individual Projects')}</span></Link>
        </Menu.Item>}
      </Menu>
    )
  }
}

const enhancer = compose(
  translate('lang'),
)
export default enhancer(SideMenu);

const styles = {

  menu: {
    width: '230px',
    minHeight: '100vh',
    height: '100%',
    boxShadow: '1px -25px 10px 0 #D9E4EC',
    position: 'fixed',
    zIndex: 2
  },

  logo: {
    width: '62px',
    height: 'auto',
    marginLeft: '28px'
  },

  head: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '10px',
    marginBottom: '10px'
  },

  title: {
    color: '#8CA0B3',
    fontSize: '17px',
    marginLeft: '10px',
    fontWeight: '600'
  }
}



// WEBPACK FOOTER //
// ./src/components/SideMenu/index.jsx